import { Component } from "react"

/* Helpers */
import { withRouter } from "../../helpers"

/* Icons */
import { ReportIcon, TableIcon } from "./RsgIcons"

/* Translate */
import { t } from "../../translates/translate"


/* Widget RSG Tabs */
class Tabs extends Component {

    render = () => {

        /* Fields */
        const { active, navigate } = this.props

        return (
            <div className="rsg--tabs">

                {/* Reports */}
                <div onClick={() => active !== "reports" && navigate("/rsg")} className={`rsg--tab ${active === "reports" ? "active" : ""}`}>
                    <ReportIcon size={14} />
                    <span>{t("rsg.tabReports")}</span>
                </div>

                {/* Games */}
                <div onClick={() => active !== "games" && navigate("/rsg/games")} className={`rsg--tab ${active === "games" ? "active" : ""}`}>
                    <TableIcon size={14} />
                    <span>{t("rsg.tabGames")}</span>
                </div>

            </div>
        )
    }

}

export default withRouter(Tabs)
